import { render, staticRenderFns } from "./EmailCampaignListItem.vue?vue&type=template&id=0d258bf5"
import script from "./EmailCampaignListItem.vue?vue&type=script&lang=js"
export * from "./EmailCampaignListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports